<template>
  <nav id="mobile-nav" class="mobile-nav">
    <div class="mobile-nav-inner">
      <button
        class="mobile-nav-btn"
        :class="{ active: activePanel === 'left' }"
        @click="$emit('navigate', 'left')"
      >
        <span class="nav-icon">📅</span>Timeline
      </button>
      <button
        class="mobile-nav-btn"
        :class="{ active: activePanel === 'center' }"
        @click="$emit('navigate', 'center')"
      >
        <span class="nav-icon">📋</span>Report
      </button>
      <button
        class="mobile-nav-btn"
        :class="{ active: activePanel === 'right' }"
        @click="$emit('navigate', 'right')"
      >
        <span class="nav-icon">🧠</span>AI
      </button>
    </div>
  </nav>
</template>

<script setup>
defineProps({
  activePanel: { type: String, default: 'center' },
})

defineEmits(['navigate'])
</script>
